<template>
    <v-app id="inspire">
        <v-navigation-drawer v-model="drawer" app fixed color="#fff" style="max-width: 250">
            <v-list-item tow-line color="#000">
                <v-list-item-avatar rounded size="40" color="#fff">
                    <v-img src="https://ik.imagekit.io/trainway/avatar.webp?updatedAt=1750180707305"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-subtitle style="color: #000">
                        <span v-if="name != null">Hello! {{ name }}</span>
                        <span v-else>Hello! Guest</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle style="color: #000">
                        <span v-if="email != null">{{ email }}</span>
                        <span v-else>Welcome</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
            <v-list nav dense>
                <v-list-item to="/wallet">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-wallet-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Wallet </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="justify-content: end">
                        <v-btn outlined text x-small style="max-width: 50px">
                            <v-icon style="font-size: 13px; margin-right: -3px">mdi-currency-inr</v-icon>
                            <span v-if="wallet">{{ wallet }}</span>
                            <span v-else>0</span>
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item to="/app-share">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-cash-100</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Collect
                            <v-icon style="font-size: 13px; margin-right: -7px">mdi-currency-inr</v-icon>
                            100</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="justify-content: end">
                        <v-btn outlined text x-small style="max-width: 50px">Invite</v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-subheader> Profile & Order </v-subheader>

                <v-list-item to="/myaccount">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-account-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>My Account</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-list-item to="/myorder">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-package-variant-closed</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>My Order</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-subheader> Other Service </v-subheader>
                <v-list-item to="/group-order">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-cart-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Group Order</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-list-item to="/track-order">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-map-marker-path</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Track Order</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-list-item to="/restaurant-signup">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-handshake-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Vendor Registration</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-list-item to="/more">
                    <v-list-item-icon>
                        <v-icon color="#000">mdi-dots-horizontal-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>More</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>

                <v-subheader> Help & Support </v-subheader>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <v-icon>mdi-phone-outline</v-icon> +91 88099-52644
                        </v-list-item-title>
                        <v-list-item-title>
                            <v-icon>mdi-email-outline</v-icon> contactus@trainway.in
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app elevation="0" color="#05445E" dark fixed top>

            <v-container class="fill-height d-flex d-sm-none align-center py-0 px-0">
                <v-app-bar-nav-icon @click="drawersidebar" style="color: #ffffff; margin-left: -19px;"
                    class="d-block d-sm-none"></v-app-bar-nav-icon>

                <v-img src="https://ik.imagekit.io/trainway/trainway.webp?updatedAt=1750180725826" max-width="130"></v-img>
                <v-spacer></v-spacer>

                <!--<v-btn to="/notification" elevation="0" color="#05445E" text class="px-1" style="min-width: 40px">
                    <v-icon>mdi-bell-badge-outline</v-icon>
                </v-btn>-->
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
                   <v-icon>mdi-cellphone-basic</v-icon>
               </v-btn>
               <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
               <v-icon>mdi-whatsapp</v-icon>
             </v-btn>
            </v-container>

            <v-container class="fill-height d-none d-sm-flex align-center">
               <router-link to="/"> <v-img src="https://ik.imagekit.io/trainway/trainway.webp?updatedAt=1750180725826" max-width="130"></v-img>  </router-link>
                <v-spacer></v-spacer>
                <v-btn to="/" elevation="0" color="#ffffff" text>HOME</v-btn>
                <v-btn to="/check-pnr-status" elevation="0" color="#ffffff" text>PNR STATUS</v-btn>
                <v-btn to="/train-running-status" elevation="0" color="#ffffff" text>RUNNING STATUS</v-btn>
                <v-btn to="/seat-availability" elevation="0" color="#ffffff" text>SEAT AVAILABILITY</v-btn>
                <v-btn to="/train-between-stations" elevation="0" color="#ffffff" text>TRAIN BETWEEN STATION</v-btn>
                <v-btn to="/login" elevation="0" color="#ffffff" text>TRACK ORDER</v-btn>
                <v-btn to="/notification" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
                    <v-icon>mdi-bell-badge-outline</v-icon>
                </v-btn>
                <v-btn href="tel:+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
               <v-icon>mdi-cellphone-basic</v-icon>
              </v-btn>
               <v-btn href="whatsapp://send?text=trainway=+9188099-52644" elevation="0" color="#ffffff" text class="px-1" style="min-width: 40px">
              <v-icon>mdi-whatsapp</v-icon>
              </v-btn>
            </v-container>

        </v-app-bar>
        <v-main>
            <v-sheet :style="'background:url(' + image + ')'" class="bannersearcbox">
                <v-container>
                    <v-row>
                        <v-col cols="12 text-center d-none d-sm-block">
                            <h2 style="font-size:40px;color:#fff;">{{ pagetitle }}</h2>
                        </v-col>
                        <v-col cols="12" md="4 mx-auto">
                            <div @click="opentrainsearch">
                                <v-text-field hide-details label="ENTER PNR | TRAIN NO. | TRAIN NAME "
                                    style="border-radius: 10px;" enable class="font-weight-bold" flat solo-inverted
                                    append-icon="mdi-magnify" @click="opentrainsearch">
                                </v-text-field>
                            </div>

                        </v-col>
                    </v-row>
                </v-container>
            </v-sheet>

            <v-container class="d-block d-sm-none">
                <v-row>
                    <v-col cols="12">
                        <v-carousel hide-delimiters height="150px" style="border-radius:10px;" interval="3000"
                            :show-arrows="false">
                            <v-carousel-item :src="image" class="img-fluid" style="height: 150px;"></v-carousel-item>
                        </v-carousel>
                    </v-col>

                </v-row>
            </v-container>

            <v-container style="background-color: #fff" class="">
                <v-row>
                    <v-col cols="4 d-sm-block d-none">
                        <p class="text-h6 font-weight-bold">Get Food in Train with easy steps</p>
                        <p>Order train food from FSSAI-approved restaurants.</p>
                    </v-col>
                    <v-col cols="12" md="8">
                        <p class="d-sm-none d-block">Get Food in Train with easy steps</p>
                        <div class="row">
                            <div class="col-3">
                                <div class="how-content text-center">
                                    <img src="https://ik.imagekit.io/trainway/1.webp?updatedAt=1750183166316" alt="How to order food in Train"
                                        class="img-fluid step" />
                                    <b>
                                        <p class="d-none d-md-block mb-0 p-14">ENTER PNR/TRAIN</p>
                                        <p class="d-md-none mb-0" style="font-size: 10px">
                                            ENTER PNR/TRAIN
                                        </p>
                                    </b>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="how-content text-center">
                                    <img src="https://ik.imagekit.io/trainway/2.webp?updatedAt=1750181902507" alt="How to order food in Train"
                                        class="img-fluid step" />
                                    <b>
                                        <p class="d-none d-md-block mb-0 p-14">
                                            CHOOSE FOOD YOU LOVE
                                        </p>
                                        <p class="d-md-none mb-0" style="font-size: 10px">
                                            CHOOSE FOOD YOU LOVE
                                        </p>
                                    </b>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="how-content text-center">
                                    <img src="https://ik.imagekit.io/trainway/3.webp?updatedAt=1750181902593" alt="How to order food in Train"
                                        class="img-fluid step" />
                                    <b>
                                        <p class="d-none d-md-block mb-0 p-14">
                                            PLACE ORDER via ONLINE/COD
                                        </p>
                                        <p class="d-md-none mb-0" style="font-size: 10px">
                                            PLACE ORDER via ONLINE/COD
                                        </p>
                                    </b>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="how-content text-center">
                                    <img src="https://ik.imagekit.io/trainway/4.webp?updatedAt=1750181902693" alt="How to order food in Train"
                                        class="img-fluid step" />
                                    <b>
                                        <p class="d-none d-md-block mb-0 p-14">
                                            GET FOOD ON YOUR SEAT
                                        </p>
                                        <p class="d-md-none mb-0" style="font-size: 10px">
                                            GET FOOD ON YOUR SEAT
                                        </p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row style="background-color: azure" class="mb-0 py-2">
                    <v-col cols="1" md="1">
                        <v-icon style="font-size: 35px">mdi-account-multiple</v-icon>
                    </v-col>
                    <v-col cols="6 pr-0" md="7">
                        <p class="d-none d-sm-block mb-0">BULK ORDER</p>
                        <p class="mb-0 d-none d-sm-block">
                            Easily place group orders, get assisted ordering and custom prices when ordering in bulk quantities. Call now 88099-52644
                        </p>
                        <p class="d-block d-sm-none mb-0 pl-sm-3 pl-4 p-14">
                            Travelling as a group of 15 or more people?  </p>
                    </v-col>
                    <v-col cols="5 text-right" md="4">
                        <v-btn class="mt-2 d-none d-sm-block float-right" color="#05445E" dark
                            style="height: 35px; padding: 11px" to="/group-order">Order Now</v-btn>
                        <v-btn class="mt-2 d-block d-sm-none float-right" color="#05445E" dark small elevation="0"
                            style="height: 35px; padding: 11px" to="/group-order">Order Now</v-btn>
                    </v-col>
                </v-row>



                <v-row class="mb-0">
                    <v-col>
                        <p style="" class="d-flex align-center" @click="opentrainsearch">
                            Today Spacial
                            <v-spacer></v-spacer>
                            See All <v-icon>mdi-chevron-right</v-icon>
                        </p>
                        <div>
                            <VueSlickCarousel v-bind="todayspecial">
                                <v-card v-for="itemsd in todayspecialItem" :key="itemsd.name" elevation="0"
                                    @click="opentrainsearch">
                                    <div class="px-2">
                                        <v-img :src="itemsd.image" class="img-fluid rounded" max-height="150"
                                            max-width="250" :eager="true"></v-img>
                                        <p class="font-weight-bold mt-2 p-12 mb-0 d-flex align-center "
                                            style="font-size: 13px">
                                            {{ itemsd.name }}
                                            <v-spacer></v-spacer>
                                            <v-icon class="p-14">mdi-currency-inr</v-icon>
                                            {{ itemsd.price }}
                                        </p>
                                        <p class="d-flex align-center p-12 mb-0">
                                            <v-icon class="p-14" color="orange">mdi-star</v-icon>4.4
                                            ({{ Math.floor(Math.random() * (999 - 200)) + 70 }})
                                        </p>
                                    </div>
                                </v-card>
                            </VueSlickCarousel>
                        </div>
                    </v-col>
                </v-row>

            </v-container>
            <v-container>

                <v-row class="mb-5">
                    <v-col>
                        <p style="font-weight: 500" class="d-flex align-center">
                            Travel Blog
                            <v-spacer></v-spacer>
                            <router-link to="/blogs" style="text-decoration: none;    color: #333;"> See All
                                <v-icon>mdi-chevron-right</v-icon>
                            </router-link>
                        </p>
                        <div>
                            <VueSlickCarousel v-bind="homebloglider" v-if="homeblog.length > 0">
                                <div v-for="itemsd in homeblog" :key="itemsd.id">
                                    <v-card elevation="0" :to="'/blog/' + itemsd.url">
                                        <v-card-text class="pt-1">
                                            <v-img :src="'https://elastic.trainway.in/images/' + itemsd.feature_img" class="img-fluid rounded" style="border-radius: 13px;  width: 100%; max-width: 100%;"
                                            :lazy-src="'https://elastic.trainway.in/images/' + itemsd.feature_img" :alt="itemsd.page_name"></v-img>
                                            <!-- <p class="font-weight-bold mt-2 p-12 mb-0 d-flex align-center" style="font-size: 13px"> {{ itemsd.page_name }} </p> -->
                                            <!-- BLOG META SECTION -->
       <div style="border-left: 4px solid #05445E; padding-left: 10px;">
          <p class="mb-0 py-2">
            <span class="mr-3" style="color: #05445E">{{ itemsd.publishDate }}</span>
            <span class="mr-3">
            <v-icon style="font-size: 14px">mdi-eye-outline</v-icon> {{ itemsd.view }}
            <v-icon small color="blue" style="font-size: 14px">mdi-eye-outline</v-icon> {{ itemsd.comment }}
            </span>
            <span class="mr-3">
             <v-icon small color="red" style="font-size: 14px">mdi-comment-outline</v-icon> {{ itemsd.comment }}
            </span>
          </p>
          <div class="text-h6 font-weight-bold" v-html="itemsd.title"></div>
          <v-btn color="orange"  class="mt-3" :href="'/blog/' + itemsd.url">Read</v-btn>
        </div>
        <!-- END BLOG META SECTION -->
                                        </v-card-text>
                                    </v-card>
                                    </div>
                            </VueSlickCarousel>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12 d-none d-sm-block" v-html="pagecontent"></v-col>
                </v-row>
                <v-row class="mb-6">
                        <div v-for="(keyworkd, i) in footerkey" :key="i" class="px-2 py-1 d-none d-sm-block">
                        <v-chip :to="'/' + keyworkd.replace(/\s+/g, '-').toLowerCase()" small class="font-weight-bold text-capitalize" > {{ keyworkd }} </v-chip>
                    </div>
                </v-row>
            </v-container>
        </v-main>
<!-- footer mobile menu -->
<v-bottom-navigation fixed temporary class="d-flex d-sm-none" id="fixedbottom">
    <v-btn to="/" class="mobileFooterMenu">
        <span class="black--text">Menu</span>
        <v-icon class="black--text">mdi-menu</v-icon>
      </v-btn>
      <v-btn  class="mobileFooterMenu" text tag="a" to="/check-pnr-status">
        <span class="black--text">PNR Status</span>
        <v-icon class="black--text">mdi-state-machine</v-icon>
      </v-btn>
      <v-btn class="mobileFooterMenu" text tag="a" to="/train-running-status">
        <span class="black--text">Spot Train</span>
        <v-icon class="black--text">mdi-train</v-icon>
      </v-btn>
      <v-btn class="mobileFooterMenu"  text tag="a" href="/train-ticket" target="_blank">
        <span class="black--text">Train Ticket</span>
        <v-icon class="black--text">mdi-ticket-account</v-icon>
      </v-btn>
      <v-btn to="/" class="mobileFooterMenu">
        <span class="black--text">Home</span>
        <v-icon class="black--text">mdi-home</v-icon>
      </v-btn>
      </v-bottom-navigation>
    <!-- footer mobile menu -->
    <Footer></Footer>

        <v-bottom-sheet v-model="sheet" fixed inset max-width="500">
            <v-sheet class="" height="800px">
                <div class="d-flex align-center">
                    <v-card-title class="font-weight-bold">Find food via train no ..</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn text @click="sheet = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-row>
                    <v-col cols="12 py-0">
                        <v-card elevation="0" class="">

                            <v-card-text>
                                <v-text-field v-model="pnrInput" flat solo-inverted type="tel" hide-details
                                    label="ENTER 10 DIGIT VALID PNR" style="border-radius: 10px;"
                                    prepend-inner-icon="mdi-train" v-on:keyup="outletbypnr">
                                    <template v-slot:append>
                                        <v-btn dark small color="#05445E" style="height: 29px; margin-top: -2px"
                                            :loading="pnrbtnload">
                                            Submit
                                        </v-btn>
                                    </template>
                                </v-text-field>
                                <div class="d-flex align-center pb-2 pt-3">
                                    <v-divider></v-divider>
                                    <span
                                        style="background: #fff;padding: 0px 6px; color: orangered; font-size: 14px; border-radius: 4px;  margin-bottom: 3px;  border: 1px dotted #ff4500;">OR</span>
                                    <v-divider></v-divider>
                                </div>

                                <v-text-field flat solo-inverted hide-details label="ENTER TRAIN NO. | NAME"
                                    v-model="trainInput" style="border-radius: 10px;" class="mb-3" append-icon="mdi-magnify"
                                    v-on:keyup="findtrainorstation"></v-text-field>
                            </v-card-text>
                            <v-card-title class="p-14 py-0"> Top trains</v-card-title>
                            <v-card-text>
                                <v-list dense>
                                    <v-list-item class="px-0" v-for="train in trains" :key="train.id">
                                        <v-list-item-icon @click="outletbytrain(train.train_no)">
                                            <v-icon>mdi-train</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content @click="outletbytrain(train.train_no)">
                                            <v-list-item-title class="p-14">{{ train.train_no }}
                                                {{ train.train_name }}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content v-if="trainload == train.train_no">
                                            <v-progress-circular :size="20" color="primary"
                                                indeterminate></v-progress-circular>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                            <!-- <v-card-title class="p-14 py-0"> Top Stations</v-card-title> -->
                            <!-- <v-card-text>
                                                <v-chip  outlined class="mb-2 mr-2 p-14" to="/">VIJAYAWADA JN</v-chip>
                                                <v-chip  outlined class="mb-2 mr-2 p-14" to="/">NAGPUR</v-chip>
                                                <v-chip  outlined class="mb-2 mr-2 p-14" to="/">KANPUR CENTRAL</v-chip>
                                                <v-chip  outlined class="mb-2 mr-2 p-14" to="/">GAYA NR</v-chip>
                                                <v-chip  outlined class="mb-2 mr-2 p-14" to="/">SURAT</v-chip>
                                            </v-card-text> -->
                        </v-card>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-bottom-sheet>

        <v-overlay :opacity="0.5" :value="overlay" color="rgb(243, 203, 174)">
            <v-progress-circular indeterminate size="64">
                Loading...
            </v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar">
            {{ snackbartext }}
            <template v-slot:action="{ attrs }">
                <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-app>
</template>

<script>
import Footer from './Footer.vue';
export default {
    components: {
        Footer
    },
    metaInfo() {
        return {
            title: this.metaTitle,
            htmlAttrs: {
                lang: "en-US",
            },
            meta: [
                { name: "description", content: this.metaDesc,},
                { name: "keywords", content: this.metaKeyword,},
                { name: "author", content: 'trainway'},
                { name: "robots", content: 'index, follow',},

                { name: "twitter:card", content: 'summary_large_image',},
                { name: "twitter:title", content: this.metaTitle,},
                { name: "twitter:description", content: this.metaDesc,},
                { name: "twitter:image", content: this.image,},
                { name: "twitter:site", content: '@trainway',},


                { property: "og:title", content: this.metaTitle,},
                { property: "og:description", content: this.metaDesc,},
                { property: "og:image", content: this.image,},
                { property: "og:url", content: this.siteUrl,},
                { property: "og:type", content: 'website',},
                { property: "og:site_name", content: 'trainway',},

            ],
            link: [{
                rel: "canonical",
                href: this.siteUrl,
            },],
            script: [{
                type: 'application/ld+json',
                json: {
                    "@context": "http://schema.org",
                    "@type": "Product",
                    "name": "trainway",
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "5",
                        "ratingCount": "25000000",
                        "reviewCount": "4500000"
                    }
                }
            }],
            script: [{
                type: 'application/ld+json',
                json: {
                    "@context": "http://schema.org",
                    "@type": "Organization",
                    "legalName": "trainway",
                    "url": "https://www.trainway.in/",
                    "logo": "https://www.trainway.in/images/favicon.ico",
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "88099-52644",
                        "contactType": "Organization"
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "DL 55 | DL Block Sector II | Bidhannagar Kolkata | West Bengal | 700091 | INDIA",
                        "addressLocality": "Kolkata",
                        "addressRegion": "WB",
                        "postalCode": "700091",
                        "addressCountry": "India"
                    },
                    "sameAs": [
                        ""
                    ]
                }
            }]
        };
    },
    data: () => ({
        metaTitle: undefined,
        metaDesc: undefined,
        metaKeyword: undefined,
        image: undefined,
        siteUrl: undefined,
        content: undefined,

        pagetitle: null,
        pagesubtitle: null,
        pagecontent: null,

        snackbar: false,
        snackbartext: "",

        overlay: true,
        sheet: false,
        drawer: false,
        pnrInput: null,
        pnrbtnload: false,
        trainInput: null,



        // sidebar
        name: null,
        email: null,
        wallet: null,
        trains: [{
            id: 2,
            train_name: "RAJDHANI EXPRES",
            train_no: "12313",
            route: "Train route  not found.",
        },
        {
            id: 7,
            train_name: "NETAJI EXPRESS",
            train_no: "12311",
            route: "Train route  not found.",
        },
        {
            id: 8,
            train_name: "TEJAS RAJ SPL",
            train_no: "12951",
            route: "Train route  not found.",
        },
        {
            id: 9,
            train_name: "NZM RAJDHANI",
            train_no: "22221",
            route: "Train route  not found.",
        },
        {
            id: 10,
            train_name: "PUNJAB MAIL",
            train_no: "12137",
            route: "Train route  not found.",
        },
        {
            id: 11,
            train_name: "HWH SMVB EXP",
            train_no: "12863",
            route: "Train route  not found.",
        },
        ],
        slider: [{
            src: "https://ik.imagekit.io/trainway/1.webp?updatedAt=1750182943536",
        },
        {
            src: "https://ik.imagekit.io/trainway/1.webp?updatedAt=1750182943536",
        },
        {
            src: "https://ik.imagekit.io/trainway/1.webp?updatedAt=1750182943536",
        },
        {
            src: "https://ik.imagekit.io/trainway/1.webp?updatedAt=1750182943536",
        },
        ],
        todayspecialItem: [{
            'name': 'JAIN THALI',
                image: 'https://ik.imagekit.io/trainway/jainthali.webp?updatedAt=1750181879328',
                price: '300'
            },
            {
                'name': 'VEG THALI',
                image: 'https://ik.imagekit.io/trainway/vegthali.webp?updatedAt=1750181879087',
                price: '275'
            },
            {
                'name': 'NON-VEG THALI',
                image: 'https://ik.imagekit.io/trainway/nonvegthali.webp?updatedAt=1750181878979',
                price: '350'
            },
            {
                'name': 'VEG CHINES FOOD',
                image: 'https://ik.imagekit.io/trainway/vegchinesfood.webp?updatedAt=1750181879166',
                price: '120'
            },
            {
                'name': 'NON-VEG CHINES FOOD',
                image: 'https://ik.imagekit.io/trainway/nonvegchinesfood.webp?updatedAt=1750181879083',
                price: '160'
            },
            {
                'name': 'LIQUID FOOD',
                image: 'https://ik.imagekit.io/trainway/liquidfood.webp?updatedAt=1750181878932',
                price: '90'
            },
        ],
        todayspecial: [{
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 6.5,
            slidesToScroll: 4,
            initialSlide: 0,
            loop: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6.5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3.1,
                    slidesToScroll: 1,
                },
            },
            ],
        },],
        homebloglider: [{
            // centerMode: true,
            // centerPadding: '60px',
            // slidesToShow: 3,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3, // Change as needed
      slidesToScroll: 1,
      autoplay: true,               // Enable auto slide
      autoplaySpeed: 3000,          // Slide every 3 seconds
      arrows: false,                // Hide default arrows (optional)
      pauseOnHover: true,           // Pause when mouse is over carousel
            responsive: [{
                breakpoint: 768,
                settings: {
                   // arrows: false,
                   // centerMode: true,
                   dots: true,
                   infinite: true,
                    centerPadding: '40px',
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    //arrows: false,
                    //centerMode: true,
                   dots: true,
                   infinite: true,
                   centerPadding: '40px',
                   slidesToShow: 2,
                }
            }
            ]
        }],

        trainload: null,
        homeblog: [],
        footerkey: [],

    }),
    methods: {
        getMeta() {

            var page = this.$route.params.pagename;

            axios.get(`/api/getMeta/` + page).then((response) => {
                this.metaTitle = response.data.meta_title;
                this.metaDesc = response.data.meta_discription;
                this.metaKeyword = response.data.meta_keyword;

                this.image = "https://elastic.trainway.in/images/undefined.webp"
                //+ response.data.feature_img; don't delet this
                this.siteUrl = 'https://www.trainway.in/' + page;
                //
                this.pagecontent = response.data.content;
                this.pagetitle = response.data.title;
                this.pagesubtitle = response.data.sub_title;

                this.footerkey = response.data.meta_keyword.split(', ')


            });
        },

        outletbypnr: function () {
            if (this.pnrInput.length == 10) {
                this.pnrbtnload = true;
                axios.get(`/api/outletbypnr/` + this.pnrInput).then((response) => {
                    if (response.data) {
                        localStorage.setItem("outlets", JSON.stringify(response.data));
                        this.$router.push("/outlets/" + this.pnrInput);
                    }
                });
            }
        },
        outletbytrain: function (trainnumner) {
            this.trainload = trainnumner;

            axios.get(`/api/outletbytrain/` + trainnumner).then((response) => {
                this.trainload = null;

                if (response.data[0]) {
                    localStorage.setItem("outlets", JSON.stringify(response.data));
                    this.$router.push("/outlets/" + trainnumner);
                } else {
                    this.snackbartext = "Sorry, we couldn’t find a route for this train | क्षमा करें, हम इस ट्रेन के लिए कोई मार्ग नहीं ढूंढ सके |";
                    this.snackbar = true;
                }
            });
        },
        opentrainsearch() {
            this.sheet = true;
        },
        findtrainorstation() {
            if (this.trainInput) {
                axios
                    .get(`/api/findtrainorstation/` + this.trainInput)
                    .then((response) => {
                        if (response.data[0]) {
                            this.trains = response.data;
                        } else {
                            this.trains = this.trains;
                        }
                    });
            }
        },
        drawersidebar() {
            var tokens = localStorage.getItem("logingToken");
            if (tokens === null) { } else {
                axios.get(`/api/getProfile/` + tokens).then((response) => {
                    this.name = response.data.name;
                    this.email = response.data.email;
                    this.wallet = response.data.balance;
                });
            }
            this.drawer = true;
        },
        getHomepost() {
            axios.get(`/api/getHomepost`).then((response) => {

                var blogs = [];
                response.data.forEach((value, key) => {
                    blogs.push(value);
                })
                this.homeblog = blogs;

            });
        },
    },
    created() {
        this.getHomepost();
        this.getMeta();
        setTimeout(() => {
            this.overlay = false;
        }, 1000);
    },
};
</script>

<style>
.bannersearcbox {
    padding: 120px 0;
    background-repeat: no-repeat !important;
    background-size: 100% !important;
    margin-bottom: 15px;
}

.bannersearcbox .v-input.v-input--hide-details {
    background-color: #fff;
}

@media(max-width:767px) {
    .bannersearcbox {
        padding: 0;
        background-repeat: no-repeat !important;
        background-size: 100% !important;
        margin-bottom: 0;
        background: #fff !important;
    }
}

.p-12 {
    color: #05445E;
    font-size: 12px !important;
}

.p-14 {
    font-size: 14px !important;
}

.step {
    max-width: 50px;
    max-height: 50px;
}
</style>
